<div class="header">
  <div>
    <a [routerLink]="'/'">
      <img src="assets/logo.png" alt="logo">
    </a>
    <span id="title">{{ appTitle }}</span>
  </div>
  <div *ngIf="userIsAuthenticated" class="icons">
    <p-avatar *ngIf="mobileDevice" icon="pi pi-bars" shape="circle" (click)="menu.toggle($event)">
    </p-avatar>
    <p-avatar (click)="helpClicked()" label="?" shape="circle"></p-avatar>
    <p-avatar *ngIf="!mobileDevice" routerLink="/settings" icon="pi pi-cog" shape="circle"></p-avatar>
    <p-avatar *ngIf="!mobileDevice" routerLink="/messages" icon="pi pi-bell" shape="circle"></p-avatar>
    <p-avatar *ngIf="!mobileDevice" routerLink="/cart" icon="pi pi-shopping-cart" shape="circle"></p-avatar>
    <p-avatar *ngIf="!userAvatarUrl" icon="pi pi-user"
      [style]="{'background-color':'darkgrey', 'color': '#ffffff'}" shape="circle"
      (click)="usermenu.toggle($event)">
    </p-avatar>
    <p-avatar *ngIf="userAvatarUrl" (click)="usermenu.toggle($event)" [image]="userAvatarUrl" shape="circle">
    </p-avatar>
  </div>
</div>
<p-slideMenu #menu [popup]="true" [model]="menuItems" [viewportHeight]="310"></p-slideMenu>
<p-slideMenu #usermenu [popup]="true" [model]="userMenuItems" [viewportHeight]="90"></p-slideMenu>